import { createAsyncThunk } from '@reduxjs/toolkit';
import authApi from '~/apis/auth';

import { LOGIN } from '~/utils/constants/actionType';
import { StorageEnum } from '~/utils/enum';
import { ILoginPayload, IRefreshTokenResponse, IResponseLogin, IResponseGetAuthUser } from '~/utils/interface/auth';

export const handleLogin = createAsyncThunk<IResponseLogin, ILoginPayload>(
  LOGIN,
  async (data: ILoginPayload, { rejectWithValue }) => {
    try {
      const res = await authApi.login(data);
      const accessToken = res.data.access_token;
      const refreshToken = res.data.refresh_token;
      localStorage.setItem(StorageEnum.ACCESS_TOKEN, accessToken);
      localStorage.setItem(StorageEnum.REFRESH_TOKEN, refreshToken);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const handleLogout = createAsyncThunk<null, void>('AUTH_LOGOUT', (_, { rejectWithValue }) => {
  try {
    localStorage.removeItem(StorageEnum.ACCESS_TOKEN);
    localStorage.removeItem(StorageEnum.REFRESH_TOKEN);
    return null;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const handleGetAuthUserInfo = createAsyncThunk<IResponseGetAuthUser, void>(
  'AUTH_GET_INFO',
  async (_, { rejectWithValue }) => {
    try {
      const res = await authApi.getInfo();
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleRefreshToken = createAsyncThunk<IRefreshTokenResponse, void>(
  'AUTH_REFRESH_TOKEN',
  async (_, { rejectWithValue }) => {
    try {
      const refreshToken = localStorage.getItem(StorageEnum.REFRESH_TOKEN);
      if (refreshToken) {
        const res = await authApi.refreshToken({ refresh_token: refreshToken });
        const accessToken = res.data.access_token;
        localStorage.setItem(StorageEnum.ACCESS_TOKEN, accessToken);
        return res.data;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
